import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { ToastRootEmits } from "reka-ui"
import type { ToastProps } from "."
import { reactiveOmit } from "@vueuse/core"
import { ToastRoot, useForwardPropsEmits } from "reka-ui"
import { cn } from "@/lib/utils"
import { toastVariants } from "."


export default /*@__PURE__*/_defineComponent({
  __name: 'Toast',
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    variant: {},
    onOpenChange: { type: Function },
    defaultOpen: { type: Boolean },
    forceMount: { type: Boolean },
    type: {},
    open: { type: Boolean },
    duration: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pause", "resume", "swipeStart", "swipeMove", "swipeCancel", "swipeEnd", "update:open"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const delegatedProps = reactiveOmit(props, "class")

const forwarded = useForwardPropsEmits(delegatedProps, emits)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ToastRoot), _mergeProps(_unref(forwarded), {
    class: _unref(cn)(_unref(toastVariants)({ variant: __props.variant }), props.class),
    "onUpdate:open": __props.onOpenChange
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class", "onUpdate:open"]))
}
}

})